import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 4);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            黄油网页游戏资讯
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            最新黄油网页游戏评测、攻略、排行榜，助你掌握黄油网页游戏第一手资讯
          </p>
        </div>

        <div className="space-y-4">
          {latestArticles.map((article) => (
            <ArticleCard
              key={article.id}
              id={article.id}
              title={article.title}
              slug={article.slug}
              excerpt={article.excerpt}
              category={article.category}
              author={article.author}
              publishDate={article.publishDate}
              readCount={article.readCount}
              image={article.image}
            />
          ))}
        </div>
      </div>
    </section>
  );
}